module.exports = __webpack_public_path__ + "static/media/lisence plate.cede3324.jpg";